import { Confirm_i18n } from "../../models/Confirm.i18n";

const confirm_es : Confirm_i18n = {
    Confirm_header: 'Confirmación de cita', 
    intro: 'Confirme los datos de su cita y verifique que su teléfono y correo estén actualizados. ¡Así nos aseguramos de que recibirá todas las notificaciones importantes!', 
    appointmentConfirmed: 'Cita confirmada', 
    thanksForUsingOurPortal: 'Gracias por usar nuestro portal', 
    sendingRequest: 'Enviando petición de agenda...', 
    sendingRequestDescription: 'Por favor, espere mientras agendamos su cita.', 
    requestDenied: 'Solicitud denegada.'
}

export default confirm_es